
import { defineComponent, onMounted, onUnmounted, reactive } from 'vue'
// import ChainTag from './ChainTag.vue'
import GreetingCard from './GreetingCard.vue'

export default defineComponent({
  components: {
    GreetingCard
  //  ChainTag
  },
  props: {
    title: {
      type: String,
      required: true
    }
  },
  setup () {
    const timing = reactive({
      minu: 0,
      second: 0
    })

    // eslint-disable-next-line no-undef
    let timer: NodeJS.Timer

    function timingHandler () {
      timing.second++

      if (timing.second === 60) {
        timing.second = 0
        timing.minu++
      }
    }

    onMounted(() => {
      timer = setInterval(() => timingHandler(), 1000)
    })

    document.body.scrollTop = 0

    onUnmounted(() => {
      clearInterval(timer)
    })

    return {
      timing
    }
  }
})
